// extracted by mini-css-extract-plugin
module.exports = {"popupIndicator":"_1qsPfePl3cbvdU4rU6G9j"};